import api from "./services/mkm.api.js"

const resource = "/musikschule"

export default{
    alle() {
        return api.get(`${resource}`);
    },
    powerAppsAlle() {
        return api.get(`/powerapps${resource}`);
    },
    kindergaerten() {
        return api.get('/institution/kindergaerten');
    }
}